export default __webpack_public_path__ + "static/media/add-task-mini.a0173910.svg";